<!--
 * @Description: 海康监控视频组件
-->

<template>
  <el-row :gutter="20" class="h-full">
    <el-col :span="24" class="h-full position-relative">
      <div id="hikplayer" class="w-full h-full" @dblclick="wholeFullScreen"></div>
      <i
        class="iconfont icon-fullscreen position-absolute text-white"
        @click="wholeFullScreen"
      ></i>
    </el-col>
  </el-row>
</template>

<script>
import dayjs from 'dayjs'
import CockpitService from '../../service/index'

export default {
  props: {
    showControlling: {
      type: Boolean,
      default: false,
    },
    codeData: {
      type: Object,
      defalut: () => {},
    },
    playerConfig: {
      type: Object,
      defalut: () => {},
    },
  },
  data() {
    return {
      isCapturePicture: false,
      oPlugin: null, // 播放器实例
      curIndex: 0, // 当前选中窗口下标
      iWind: 0, //
      videoUrl: '', // 视频流
      showVideo: false, // resize前需要判断是否实例化完成播放器
      playType: false,
      playbackTime: [],
      isBackPlay: false,
      isPausePlay: false,
      speedOptions: [1, 20, 40, 60, 80, 100],
      speed: '',
      isShow: false,
      playback: {
        startTime: '2021-07-26T00:00:00',
        endTime: '2021-07-26T23:59:59',
        // valueFormat: moment.HTML5_FMT.DATETIME_LOCAL_SECONDS,
        seekStart: '2021-07-26T12:00:00',
        rate: '',
      },
    }
  },
  watch: {
    'codeData.code': {
      deep: true,
      immediate: true,
      handler(val) {
        if (val) {
          if ('WebSocket' in window && this.videoUrl) {
            // 关闭上一个websocket连接
            const ws = new WebSocket(this.videoUrl)
            ws.close()
          }
          if (this.oPlugin) {
            this.stopPlay()
          }
          this.$nextTick(() => {
            setTimeout(() => {
              this.initCamera()
            }, 500)
          })
        }
      },
    },
  },
  computed: {},
  created() {},
  mounted() {
    this.init()
  },
  methods: {
    init() {
      window.addEventListener('resize', this.onResize)
    },
    // 云台控制
    switchChange(val) {
      if (val) {
        // 历史回放
        this.isShow = true
        if ('WebSocket' in window && this.videoUrl) {
          // 关闭上一个websocket连接
          const ws = new WebSocket(this.videoUrl)
          ws.close()
        }
      } else {
        // 实时播放
        this.isShow = false
        this.isBackPlay = false
        this.stopPlay()
        this.initCamera()
      }
    },
    // 播放器配置
    initCamera() {
      this.oPlugin = new JSPlugin({
        szId: 'hikplayer', // 容器id 需要英文字母开头
        szBasePath: '/lib/video/HKh5Player/', // 资源文件
        iMaxSplit: 1, // 分屏播放，当前为1
        oStyle: {
          // 设置播放器样式
          border: '#FFCC00',
          borderSelect: '#FFCC00',
          background: '#000',
        },
        openDebug: true,
      })
      window.oPluginPlayer = this.oPlugin
      this.initPlugin()
    },
    // 事件初始化
    initPlugin() {
      const that = this
      this.oPlugin.JS_SetWindowControlCallback({
        windowEventSelect(iWndIndex) {
          // 插件选中窗口回调
          this.iWind = iWndIndex
        },
        pluginErrorHandler(iWndIndex, iErrorCode, oError) {
          // 插件错误回调
          console.error(
            `插件错误回调   window-${iWndIndex}, errorCode: ${iErrorCode}`,
            oError
          )
        },
        windowEventOver(iWndIndex) {
          // 鼠标移过回调
          console.log('鼠标移过回调')
        },
        windowEventOut(iWndIndex) {
          // 鼠标移出回调
          console.log('鼠标移出回调')
        },
        windowEventUp(iWndIndex) {
          // 鼠标mouseup事件回调
          console.log('鼠标mouseup事件回调')
        },
        windowFullCcreenChange(bFull) {
          // 全屏切换回调
          console.log('全屏切换回调')
        },
        firstFrameDisplay(iWndIndex, iWidth, iHeight) {
          // 首帧显示回调
          console.log(iWndIndex, iWidth, iHeight)
        },
        performanceLack() {
          // 性能不足回调
          console.log('性能不足回调')
        },
      })
      this.oPlugin
        .JS_SetOptions({
          // bSupportSound: false  //是否支持音频，默认支持
          bSupporDoubleClickFull: false, // 是否双击窗口全屏，默认支持
          // bOnlySupportMSE: true  //只支持MSE
          // bOnlySupportJSDecoder: true  //只支持JSDecoder
        })
        .then(async () => {
          // 播放器实例化完成
          this.showVideo = true
          this.getWS()
        })
    },
    // 获取视频流
    async getWS() {
      const params = {
        cameraIndexCode: this.codeData.code,
        streamType: 0, // 码流类型：0-主码流，1-子码流，2-第三码流，默认0
        protocol: 'ws', // 取流协议('hik, rtsp, rtmp, hls')，默认hik
        transmode: 1, // 传输协议，0-UDP, 1-TCP, 默认TCP
        expand: 'transcode=0',
        streamform: 'ps',
      }
      const params2 = {
        url: '/artemis/api/video/v1/cameras/previewURLs',
        input: JSON.stringify(params),
      }
      const [err, res] = await CockpitService.getIotCameraPreview(params2)
      if (res && res.data) {
        this.videoUrl = res.data.url
        this.realplay()
      }
    },
    // 截图
    capturePicture() {
      this.isCapturePicture = true
      this.oPlugin
        .JS_CapturePicture(
          0,
          `监控截图${dayjs().format('YYYYMMDDHHmmss')}`,
          'JPEG'
        )
        .then((res) => {
          this.isCapturePicture = false
          console.log(res, '截图')
        })
        .catch(() => {
          this.isCapturePicture = false
        })
    },
    // 播放视频
    realplay() {
      console.log(this.videoUrl, 'videoUrl')
      this.oPlugin
        .JS_Play(
          this.videoUrl,
          {
            playURL: this.videoUrl,
            mode: 1, // 0：普通模式   1：高级模式
          },
          0
        )
        .then(() => {
          console.log('realplay success')
        })
        .catch(() => {
          console.log('realplay failed')
        })
    },
    // 设置窗口大小
    resizeVideo() {
      if (this.showVideo) {
        this.oPlugin
          .JS_Resize()
          .then(() => {
            console.log('resizeplay success')
          })
          .catch(() => {
            console.log('resizeplay failed')
          })
      }
    },
    // 全屏
    wholeFullScreen() {
      this.oPlugin.JS_FullScreenDisplay(true).then(
        () => {},
        (e) => {
          console.log(e)
        }
      )
    },
    // 时间段选择(转为IOS8601时间格式)
    timeChange(val) {
      const startTime = dayjs(val[0])
        .add(8, 'hour')
        .format('YYYY-MM-DD HH:mm:ss')
      const endTime = dayjs(val[1])
        .add(8, 'hour')
        .format('YYYY-MM-DD HH:mm:ss')
      this.playback.startTime = new Date(startTime)
        .toISOString()
        .replace('Z', '+08:00')
      this.playback.endTime = new Date(endTime)
        .toISOString()
        .replace('Z', '+08:00')
    },
    // 获取视频回放流
    async getPlaybackUrl() {
      let playUrl = ''
      const params = {
        cameraIndexCode: this.codeData.code,
        recordLocation: _.isNil(
          window.currentEnv.VUE_APP_MONITOR_RECORDLOCATION
        )
          ? 1
          : window.currentEnv.VUE_APP_MONITOR_RECORDLOCATION, // 0:中心存储,1:设备存储
        protocol: this.playerConfig.protocol,
        transmode: this.playerConfig.transmode,
        beginTime: this.playback.startTime,
        endTime: this.playback.endTime,
        expand: 'transcode=0',
        streamform: 'ps',
        lockType: 0,
      }
      const [err, res] = await CockpitService.getPlaybackUrls(params)
      console.log(res, '获取回放视频流的res')
      if (res && res.code == '0') {
        playUrl = res.data.url
        this.isBackPlay = true
      }
      return playUrl
    },
    // 开始回放
    async playbackStart() {
      if (!this.playbackTime.length) {
        this.$message.warning('请先选择回放时间段！')
        return
      }
      if ('WebSocket' in window && this.videoUrl) {
        // 关闭上一个websocket连接
        const ws = new WebSocket(this.videoUrl)
        ws.close()
      }
      if (this.oPlugin) {
        this.stopPlay()
      }
      const playURL = await this.getPlaybackUrl()
      const mode = 1
      const startTime = this.playback.startTime
      const endTime = this.playback.endTime

      this.oPlugin
        .JS_Play(playURL, { playURL, mode }, 0, startTime, endTime)
        .then(
          () => {
            console.log('playbackStart success')
            this.playback.rate = 1
          },
          (e) => {
            console.error(e)
          }
        )
    },
    // 停止回放
    stopPlay() {
      this.isBackPlay = false
      this.isPausePlay = false
      this.oPlugin.JS_StopRealPlayAll().then(
        () => {
          this.playback.rate = 0
          console.log('JS_StopRealPlayAll success')
        },
        (e) => {
          console.error(e)
        }
      )
    },
    // 暂停
    playbackPause() {
      this.isPausePlay = !this.isPausePlay
      this.oPlugin.JS_Pause(0).then(
        () => {
          console.log('JS_Pause success')
        },
        (e) => {
          console.error(e)
        }
      )
    },
    // 播放
    playbackResume() {
      this.isPausePlay = !this.isPausePlay
      this.oPlugin.JS_Resume(0).then(
        () => {
          console.log('JS_Resume success')
        },
        (e) => {
          console.error(e)
        }
      )
    },
    // 慢放
    playbackSlow() {
      this.oPlugin.JS_Slow(0).then(
        (rate) => {
          this.playback.rate = rate
        },
        (e) => {
          console.error(e)
        }
      )
    },
    // 快放
    playbackFast() {
      this.oPlugin.JS_Fast(0).then(
        (rate) => {
          this.playback.rate = rate
        },
        (e) => {
          console.error(e)
        }
      )
    },
    // 摄像头方向控制
    async controlCamera(direction, action) {
      const params = {
        cameraIndexCode: this.codeData.code,
        action,
        command: direction,
        speed: this.speed ? this.speed : '50',
      }
      const [err, res] = await CockpitService.getMonitorControlling(params)
      if (res && res.code == '0') {
        console.log('摄像头操作成功！')
      }
    },
    // 单个全屏
    fullScreen() {
      this.oPlugin
        .JS_FullScreenSingle(this.curIndex)
        .then(() => {
          console.log('JS_FullScreenDisplay success')
        })
        .catch((e) => {
          console.log(e, 'JS_FullScreenDisplay faild')
        })
    },
    onResize() {
      this.oPlugin.JS_Resize()
    },
  },
  beforeDestroy() {
    this.stopPlay()
    window.removeEventListener('resize', this.onResize)
  },
}
</script>
<style lang="scss" scoped>
.icon-fullscreen {
  font-size: 18px;
  bottom: 10px;
  right: 25px;
}
.playback-button {
  display: flex;
  justify-content: space-around;
  button {
    width: 50%;
  }
}
.controllar-image {
  width: 30px;
  cursor: pointer;
  &_up {
    transform: rotate(90deg);
    // margin-left: 40px;
  }
  &_right {
    margin-left: 50px;
    transform: rotate(180deg);
  }
  &_down {
    transform: rotate(-90deg);
    // margin-left: 40px;
  }
}
::v-deep {
  .el-range-editor.el-input__inner {
    height: 28px;
  }
  .el-date-editor .el-range-separator,
  .el-date-editor .el-range__icon,
  .el-date-editor .el-range__close-icon {
    line-height: 22px;
  }
  .el-range-editor .el-range-input {
    background: transparent;
    color: #909399;
  }
  .el-switch__label {
    color: #c0c4cc;
  }
  .el-switch__label.is-active {
    color: #f98b0c;
  }
}
.screenshot-btn {
  width: auto !important;
  padding: 0 10px !important;
  height: 25px !important;
}
#monitorOprate {
  position: absolute;
  right: 20px;
  bottom: 20px;
}
.tc {
  text-align: center;
}
</style>
